import React, { useState } from 'react';
import PortalShell from './PortalShell';
import GalleryManager from './GalleryManager';
import { useAuth } from './AuthContext';
import './Portal.css';

const TABS = [{ id: 'gallery', label: 'My gallery' }];

export default function OwnerPortal() {
  const [tab, setTab] = useState('gallery');
  const { user } = useAuth();
  const firstName = user && user.name ? user.name.split(' ')[0] : 'there';

  return (
    <PortalShell
      roleLabel="Owner"
      tabs={TABS}
      activeTab={tab}
      onTabChange={setTab}
      title={'Welcome back, ' + firstName}
      subtitle="Add photos of jobs you have finished and they appear in the gallery on your website right away. You can rename them, reorder them, temporarily hide one, or delete it for good."
    >
      {tab === 'gallery' && <GalleryManager />}
    </PortalShell>
  );
}
